<ng-container *ngIf="this.sourceAuh.accessDenied;else showLib">
    <div class="col-12 ng-star-inserted">
        <p-messages [(value)]="enableErrorMessageCourtier" [enableService]="false" [closable]="false"></p-messages>
    </div>
</ng-container>
<ng-template #showLib>
    <lib-mes-remboursements [configuration]="configuration" [showBtnExtraction]="showBtnExtraction" ></lib-mes-remboursements>
</ng-template>